/**
 * Anatomy integration — domain routes (mounted at /app/anatomy/* by App.tsx).
 * Follow-ups and meetings for AnatomyAccess; administration (test user, activity) for the desk; settings for Admin.
 */
import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Center } from '@/components/ui';
import { Loader } from '@/components/ui/feedback';
import MainLayout from '../../../layouts/MainLayout';
import ProtectedRoute from '@/components/ccms-components/auth/components/ProtectedRoute';
import AnatomyDashboardPage from './dashboard';

const FollowUpTypesPage = lazy(() => import('./follow-ups'));
const NewFollowUpPage = lazy(() => import('./follow-ups/new'));
const SentFollowUpsPage = lazy(() => import('./follow-ups/sent'));
const MeetingsPage = lazy(() => import('./meetings'));
const RegisterForMeetingPage = lazy(() => import('./meetings/register'));
const RegistrationsPage = lazy(() => import('./meetings/registrations'));
const NextMeetingPage = lazy(() => import('./meetings/next'));
const TestUserPage = lazy(() => import('./test-user'));
const ActivityPage = lazy(() => import('./activity'));
const SettingsPage = lazy(() => import('./settings'));

export default function AnatomyIntegrationRoutes() {
  return (
    <MainLayout domainKey="anatomy">
      <Suspense fallback={<Center h={400}><Loader size="lg" /></Center>}>
        <Routes>
          <Route path="/" element={<AnatomyDashboardPage />} />
          <Route path="/follow-ups" element={<FollowUpTypesPage />} />
          <Route path="/follow-ups/new" element={<NewFollowUpPage />} />
          <Route path="/follow-ups/sent" element={<SentFollowUpsPage />} />
          <Route path="/meetings" element={<MeetingsPage />} />
          <Route path="/meetings/register" element={<RegisterForMeetingPage />} />
          <Route path="/meetings/registrations" element={<RegistrationsPage />} />
          <Route path="/meetings/next" element={<NextMeetingPage />} />
          <Route path="/test-user" element={<TestUserPage />} />
          <Route path="/activity" element={<ActivityPage />} />
          <Route path="/settings" element={<ProtectedRoute requiredRoles={['Admin']}><SettingsPage /></ProtectedRoute>} />
          {/* Earlier links */}
          <Route path="/people" element={<Navigate to="/app/anatomy/follow-ups/new" replace />} />
          <Route path="/meetings/create" element={<Navigate to="/app/anatomy/meetings/register" replace />} />
          <Route path="*" element={<Navigate to="/app/anatomy" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
